var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',[_vm._v("Products:")]),_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{name: 'terms-of-service.livestream'}}},[_vm._v("Livestream")])],1),_c('li',[_c('router-link',{attrs:{"to":{name: 'terms-of-service.livestream-alexa'}}},[_vm._v("Livestream (Alexa)")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }